import {
  FETCH_UPSELLS_REQUEST,
  FETCH_UPSELLS_SUCCESS,
  FETCH_UPSELLS_FAILURE,
  ADD_UPSELL_PRODUCT_REQUEST,
  ADD_UPSELL_PRODUCT_SUCCESS,
  ADD_UPSELL_PRODUCT_FAILURE,
  REMOVE_UPSELL_PRODUCT_REQUEST,
  REMOVE_UPSELL_PRODUCT_SUCCESS,
  REMOVE_UPSELL_PRODUCT_FAILURE,
  REMOVE_UPSELL_PRODUCTS_BATCH_REQUEST,
  REMOVE_UPSELL_PRODUCTS_BATCH_SUCCESS,
  REMOVE_UPSELL_PRODUCTS_BATCH_FAILURE,
} from './actionTypes';
import {
  FetchUpsellsRequest,
  FetchUpsellsSuccess,
  FetchUpsellsSuccessPayload,
  FetchUpsellsFailure,
  FetchUpsellsFailurePayload,
  AddUpsellProductRequest,
  AddUpsellProductRequestPayload,
  AddUpsellProductSuccess,
  AddUpsellProductSuccessPayload,
  AddUpsellProductFailure,
  AddUpsellProductFailurePayload,
  RemoveUpsellProductRequest,
  RemoveUpsellProductRequestPayload,
  RemoveUpsellProductSuccess,
  RemoveUpsellProductSuccessPayload,
  RemoveUpsellProductFailure,
  RemoveUpsellProductFailurePayload,
  RemoveUpsellProductsBatchRequest,
  RemoveUpsellProductsBatchRequestPayload,
  RemoveUpsellProductsBatchSuccess,
  RemoveUpsellProductsBatchSuccessPayload,
  RemoveUpsellProductsBatchFailure,
  RemoveUpsellProductsBatchFailurePayload,
} from './types';

export const fetchUpsellsRequest = (): FetchUpsellsRequest => ({
  type: FETCH_UPSELLS_REQUEST,
});

export const fetchUpsellsSuccess = (payload: FetchUpsellsSuccessPayload): FetchUpsellsSuccess => ({
  type: FETCH_UPSELLS_SUCCESS,
  payload,
});

export const fetchUpsellsFailure = (payload: FetchUpsellsFailurePayload): FetchUpsellsFailure => ({
  type: FETCH_UPSELLS_FAILURE,
  payload,
});

export const addUpsellProductRequest = (
  payload: AddUpsellProductRequestPayload,
): AddUpsellProductRequest => ({
  type: ADD_UPSELL_PRODUCT_REQUEST,
  payload,
});

export const addUpsellProductSuccess = (
  payload: AddUpsellProductSuccessPayload,
): AddUpsellProductSuccess => ({
  type: ADD_UPSELL_PRODUCT_SUCCESS,
  payload,
});

export const addUpsellProductFailure = (
  payload: AddUpsellProductFailurePayload,
): AddUpsellProductFailure => ({
  type: ADD_UPSELL_PRODUCT_FAILURE,
  payload,
});

export const removeUpsellProductRequest = (
  payload: RemoveUpsellProductRequestPayload,
): RemoveUpsellProductRequest => ({
  type: REMOVE_UPSELL_PRODUCT_REQUEST,
  payload,
});

export const removeUpsellProductSuccess = (
  payload: RemoveUpsellProductSuccessPayload,
): RemoveUpsellProductSuccess => ({
  type: REMOVE_UPSELL_PRODUCT_SUCCESS,
  payload,
});

export const removeUpsellProductFailure = (
  payload: RemoveUpsellProductFailurePayload,
): RemoveUpsellProductFailure => ({
  type: REMOVE_UPSELL_PRODUCT_FAILURE,
  payload,
});

export const removeUpsellProductsBatchRequest = (
  payload: RemoveUpsellProductsBatchRequestPayload,
): RemoveUpsellProductsBatchRequest => ({
  type: REMOVE_UPSELL_PRODUCTS_BATCH_REQUEST,
  payload,
});

export const removeUpsellProductsBatchSuccess = (
  payload: RemoveUpsellProductsBatchSuccessPayload,
): RemoveUpsellProductsBatchSuccess => ({
  type: REMOVE_UPSELL_PRODUCTS_BATCH_SUCCESS,
  payload,
});

export const removeUpsellProductsBatchFailure = (
  payload: RemoveUpsellProductsBatchFailurePayload,
): RemoveUpsellProductsBatchFailure => ({
  type: REMOVE_UPSELL_PRODUCTS_BATCH_FAILURE,
  payload,
});
